import type { Api, Vehicle } from '@cruz-com/lookup'
import { defaultPostHeader } from '@/settings'
import { baseURL, formatFetchError, getHeader } from '../util'

export async function vehicleGenerationMakes(): Promise<Api.Result<Vehicle.GenerationMake[]>> {
  try {
    const headers = await getHeader()
    const res = await fetch(`${baseURL}/data/vehicle-generation/makes`, {
      method: 'GET',
      headers,
    })
    const d = await res.json()
    if (!res.ok) {
      return Promise.reject(d)
    }
    return Promise.resolve(d)
  } catch (err) {
    return Promise.reject(formatFetchError(err))
  }
}

export async function vehicleGenerationModels(make: string): Promise<Api.Result<Vehicle.Generation[]>> {
  try {
    if (!make) {
      return Promise.resolve({ meta: {}, links: {}, data: [] })
    }
    const headers = await getHeader()
    const res = await fetch(`${baseURL}/data/vehicle-generation/models?make=${make}`, {
      method: 'GET',
      headers,
    })
    const d = await res.json()
    if (!res.ok) {
      return Promise.reject(d)
    }
    return Promise.resolve(d)
  } catch (err) {
    return Promise.reject(formatFetchError(err))
  }
}

export async function updateVehicleGeneration(data: Vehicle.Generation): Promise<Api.Result<Vehicle.Generation>> {
  try {
    const headers = await getHeader()
    const res = await fetch(`${baseURL}/data/vehicle-generation`, {
      method: 'POST',
      headers: { ...headers, ...defaultPostHeader },
      body: JSON.stringify(data),
    })
    const d = await res.json()
    if (!res.ok) {
      return Promise.reject(d)
    }
    return Promise.resolve(d)
  } catch (err) {
    return Promise.reject(formatFetchError(err))
  }
}
